import { Store } from 'react-redux';

import Wix from './wix-sdk-polyfill';
import { setSignedInstance } from '../state/site/actions';

interface InstanceEvent {
  instance: string;
}

export function listenToSignedInstanceChange<State>(store: Store<State>) {
  Wix.addEventListener(Wix.Events.INSTANCE_CHANGED, (event: InstanceEvent) => {
    if (event.instance) {
      store.dispatch(setSignedInstance(event.instance));
    }
  });
}
